import { type FC } from 'react'

export const PrivateBadge: FC = () => {
  return (
    <div className='d-flex align-content-center align-items-center px-1 gap-1 zocks-border-0.25 zocks-border-primary-light'>
      <i className='bi bi-lock' />
      <span className='button-small'>Private</span>
    </div>
  )
}
